import { createTheme } from '@mui/material';
import { deepmerge } from '@mui/utils';

import * as Colors from './colors';
import { alertThemeOptions } from './components/Alert';
import { buttonThemeOptions } from './components/Button';
import { cardThemeOptions } from './components/Card';
import { chipThemeOptions } from './components/Chip';
import { dataGridThemeOptions } from './components/DataGrid';
import { menuThemeOptions } from './components/Menu';
import { menuItemThemeOptions } from './components/MenuItem';
import { popperThemeOptions } from './components/Popper';
import { skeletonThemeOptions } from './components/Skeleton';
import { tabThemeOptions } from './components/Tab';
import { tabsThemeOptions } from './components/Tabs';
import { lightPaletteThemeOptions } from './palette/light';
import { typographyThemeOptions } from './typography';

let themeOptions = deepmerge(typographyThemeOptions, lightPaletteThemeOptions);

themeOptions = deepmerge(themeOptions, alertThemeOptions);
themeOptions = deepmerge(themeOptions, buttonThemeOptions);
themeOptions = deepmerge(themeOptions, chipThemeOptions);
themeOptions = deepmerge(themeOptions, dataGridThemeOptions);
themeOptions = deepmerge(themeOptions, menuThemeOptions);
themeOptions = deepmerge(themeOptions, menuItemThemeOptions);
themeOptions = deepmerge(themeOptions, popperThemeOptions);
themeOptions = deepmerge(themeOptions, skeletonThemeOptions);
themeOptions = deepmerge(themeOptions, tabThemeOptions);
themeOptions = deepmerge(themeOptions, tabsThemeOptions);
themeOptions = deepmerge(themeOptions, cardThemeOptions);

const theme = createTheme(themeOptions);

export { theme };

export { Colors };

export type {
  SecurityApplicationsPalette,
  SecurityApplicationsThemeOptions,
} from './types';

export {
  SeverityLevel,
  severityColor,
  severityIcon,
  severityByCategoryColorPalette,
} from './severity';
